




































import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      showMenu: true,
      isHome: true,
      transitionName: 'router-this',
    };
  },
   methods: {
    toggleMenu() {
        this.showMenu = !this.showMenu;
      },
  },
  watch: {
    $route: {
      handler(to, from) {
        const toDepth = to.path.split('/').length;
        const fromDepth = from.path.split('/').length;
        if (toDepth < fromDepth) {
          this.transitionName = 'router-prev';
        } else if (toDepth > fromDepth) {
          this.transitionName = 'router-next';
        } else {
          this.transitionName = 'router-this';
        }
        if (this.$route.name === 'home') {
          this.isHome = true;
        } else {
          this.isHome = false;
        }
      },
    },
  },
});
